import { Box, Stack, Heading, Text, SimpleGrid, Container } from '@chakra-ui/react';
import { Navigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useMemo } from 'react';

const AdminInventory = () => {
    const { userInfo } = useSelector((state) => state.user);
    const { products } = useSelector((state) => state.product);
    const location = useLocation();

    const inventoryStats = useMemo(() => {
        if (!products || products.length === 0) return null;

        const totalProducts = products.length;
        const totalStockPieces = products.reduce((sum, p) => sum + Number(p.stock), 0);
        const totalStockValue = products.reduce(
            (sum, p) => sum + (Number(p.stock) * Number(p.price)),
            0
        );

        // 🔹 DRS-es termékek
        const drsProducts = products.filter(p => p.visszavalto === true);
        const drsTotalPieces = drsProducts.reduce((sum, p) => sum + Number(p.stock), 0);
        const drsValue = drsTotalPieces * 50;

        // 🔹 DRS-től megtisztított érték
        const totalStockValueWithoutDRS = totalStockValue - drsValue;

        return {
            totalProducts,
            totalStockPieces,
            totalStockValue,
            drsTotalPieces,
            drsValue,
            totalStockValueWithoutDRS
        };
    }, [products]);



    return userInfo && userInfo.isAdmin ? (
        <Container maxW='container.xl'>
            <Box p="20px" minH="100vh">
                <Stack direction={{ base: 'column', lg: 'row' }} align={{ lg: 'flex-start' }}>
                    <Stack flex="1.5" spacing="8">
                        <Heading textAlign="center" fontSize="2xl" fontWeight="extrabold">
                            Admin Leltár
                        </Heading>

                        {inventoryStats && (
                            <Box bg="gray.100" p="6" rounded="xl" boxShadow="md">
                                <SimpleGrid columns={{ base: 1, md: 2 }} spacing="6">
                                    <Box>
                                        <Text fontWeight="bold">🛒 Termékek száma a rendszerben:</Text>
                                        <Text>{inventoryStats.totalProducts} db</Text>
                                    </Box>

                                    <Box>
                                        <Text fontWeight="bold">📦 Készleten lévő darabszám összesen:</Text>
                                        <Text>{inventoryStats.totalStockPieces} db</Text>
                                    </Box>

                                    <Box>
                                        <Text fontWeight="bold">💰 Teljes készletérték (DRS-sel együtt):</Text>
                                        <Text>{inventoryStats.totalStockValue.toLocaleString()} Ft</Text>
                                    </Box>

                                    <Box>
                                        <Text fontWeight="bold">♻️ DRS-es termékek összdarabszáma:</Text>
                                        <Text>{inventoryStats.drsTotalPieces} db</Text>
                                    </Box>

                                    <Box>
                                        <Text fontWeight="bold">♻️ DRS érték (50 Ft/db):</Text>
                                        <Text>{inventoryStats.drsValue.toLocaleString()} Ft</Text>
                                    </Box>

                                    <Box>
                                        <Text fontWeight="bold">💰 Készletérték DRS nélkül:</Text>
                                        <Text color="red.500" fontWeight="bold">
                                            {inventoryStats.totalStockValueWithoutDRS.toLocaleString()} Ft
                                        </Text>
                                    </Box>
                                </SimpleGrid>
                            </Box>
                        )}


                    </Stack>
                </Stack>
            </Box>
        </Container>
    ) : (
        <Navigate to="/" replace state={{ from: location }} />
    );
};

export default AdminInventory;
